import Button from "../../../shared/components/Button";
import type { Camera } from "../model";

export type GridColumns = 2 | 3 | 4;
export type StatusFilter = "All" | Camera["status"];

export function CameraToolbar({
  gridColumns,
  hasFilters,
  protocolFilter,
  protocols,
  search,
  statusFilter,
  onClearFilters,
  onGridColumnsChange,
  onProtocolFilterChange,
  onSearchChange,
  onStatusFilterChange,
}: {
  gridColumns: GridColumns;
  hasFilters: boolean;
  protocolFilter: string;
  protocols: string[];
  search: string;
  statusFilter: StatusFilter;
  onClearFilters: () => void;
  onGridColumnsChange: (columns: GridColumns) => void;
  onProtocolFilterChange: (protocol: string) => void;
  onSearchChange: (search: string) => void;
  onStatusFilterChange: (status: StatusFilter) => void;
}) {
  return (
    <div className="camera-toolbar">
      <label className="search-field">
        <span>Search cameras</span>
        <input onChange={(event) => onSearchChange(event.target.value)} placeholder="Name, location, or ID" type="search" value={search} />
      </label>
      <label className="toolbar-field">
        <span>Status</span>
        <select aria-label="Filter cameras by status" onChange={(event) => onStatusFilterChange(event.target.value as StatusFilter)} value={statusFilter}>
          <option value="All">All statuses</option>
          <option value="Live">Live</option>
          <option value="Warning">Warning</option>
          <option value="Offline">Offline</option>
        </select>
      </label>
      <label className="toolbar-field">
        <span>Protocol</span>
        <select aria-label="Filter cameras by protocol" onChange={(event) => onProtocolFilterChange(event.target.value)} value={protocolFilter}>
          <option value="All">All protocols</option>
          {protocols.map((protocol) => <option key={protocol} value={protocol}>{protocol.toUpperCase()}</option>)}
        </select>
      </label>
      <label className="toolbar-field">
        <span>Grid</span>
        <select aria-label="Choose camera grid density" onChange={(event) => onGridColumnsChange(Number(event.target.value) as GridColumns)} value={gridColumns}>
          <option value={2}>2 × 2</option>
          <option value={3}>3 × 3</option>
          <option value={4}>4 × 4</option>
        </select>
      </label>
      {hasFilters && <Button onClick={onClearFilters} variant="ghost">Clear filters</Button>}
    </div>
  );
}
